export default "__VITE_ASSET__Cxl2eRkm__"